<template>
	<div class="amount-of-money-area pa-2">
		<div class="amount-of-money-area__result mb-3">
			<h3>総原価: {{ Number(money.totalCost).toLocaleString() }}円</h3>
			<h3>見積額（総額）: {{ Number(money.quotationAmount).toLocaleString() }}円</h3>
		</div>

		<v-text-field
			type="number"
			v-if="contract && contract !== 'nil'"
			v-model="money.orderedAmount"
			class="mt-4"
			label="受注額"
			outlined
			dense
		></v-text-field>

		<v-text-field
			type="number"
			v-if="contract == false && contract !== 'nil'"
			v-model="money.lostAmount"
			class="mt-4"
			label="失注額"
			outlined
			dense
		></v-text-field>

		<h2>製品情報</h2>
		<v-combobox
			ref="product_combobox"
			v-model="money.product"
			label="製品を探す"
			item-text="name"
			item-value="id"
			class="mt-4"
			outlined
			dense
			:hint="productHint"
			@keyup="setSearchProduct"
			@change="changeMatterProduct"
			:items="products"
			no-data-text="選択肢がありません"
		/>

		<div class="product-card">
			<MatterNewProductNewCard
				v-for="(matter_product, index) in matter_products"
				:key="`matter_product-${index}`"
				:index="index"
				:product="matter_product"
				@delete-product="deleteProduct($event)"
				@change-product="changeProduct($event, index)"
				class="mt-3"
				:contract="contract"
			/>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"

import MatterNewProductNewCard from "./MatterNewProductNewCard.vue"

export default {
	components: {
		MatterNewProductNewCard,
	},
	props: {
		money: {
			type: Object,
			required: false,
			default: () => {},
		},
		matter_products: {
			type: Array,
			required: false,
			default: () => [],
		},
		contract: {
			type: [String, Boolean],
		},
	},
	data() {
		return {
			products: [],
			productKeyword: null,
			searchProductTimer: null,
			errorProductFlag: false,
		}
	},
	methods: {
		setSearchProduct(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.products = []
			this.productKeyword = e.target.value
			clearTimeout(this.searchProductTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.productKeyword.length) return // 0文字の場合はreturn
			this.searchProductTimer = setTimeout(this.searchProduct, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		setProductCard(product) {
			this.matter_products.push(product)
		},

		searchProduct() {
			const params = {
				q: {
					name_cont: this.productKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_products", {
					headers,
					params,
				})
				.then((res) => {
					this.searchProductTimer = null
					this.products = res.data.products
					this.errorProductFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeMatterProduct() {
			let addObject = {
				product_unit_price: 0,
				product_quantity: 1,
				product_sub_name: "",
			}
			const product = { ...this.money.product, ...addObject }
			this.setProductCard(product)

			// テキスト追加時の削除
			this.errorProductFlag = true
			this.money.product = null
			this.$refs.product_combobox.reset()
		},
		deleteProduct: function (i_num) {
			this.matter_products.splice(i_num, 1)
		},
		changeProduct(matter_product, index) {
			this.matter_products[index] = matter_product
			this.setQuotationAmount()
			this.setTotalCost()
		},
		setQuotationAmount() {
			let price = 0
			this.matter_products.forEach((p) => {
				price += Number(p.product_unit_price) * p.product_quantity
			})
			this.money.quotationAmount = price
		},
		setTotalCost() {
			let cost = 0
			this.matter_products.forEach((p) => {
				cost += Number(p.cost_price) * p.product_quantity
			})
			this.money.totalCost = cost
		},
		setQuotationAmount() {
			let price = 0
			this.matter_products.forEach((p) => {
				price += Number(p.product_unit_price) * p.product_quantity
			})
			this.money.quotationAmount = price
		},
		setTotalCost() {
			let cost = 0
			this.matter_products.forEach((p) => {
				cost += Number(p.cost_price) * p.product_quantity
			})
			this.money.totalCost = cost
		},
	},
	computed: {
		productHint() {
			if (this.products.length) {
				return "製品を選択してください"
			} else if (this.searchProductTimer) {
				return "製品情報を取得しています"
			} else if (!this.products.length && this.productKeyword) {
				return "該当する製品が存在していません"
			} else if (this.errorProductFlag && !this.productKeyword) {
				return "選択肢から製品を選択してください"
			} else {
				return "製品を入力してください"
			}
		},
		setOrderedAmount: {
			get() {
				return this.money.orderedAmount
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setLostAmount: {
			get() {
				return this.money.lostAmount
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/variable.scss";

.product-card {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}
</style>
